require.config({
    name: "main",
    urlArgs: "version=1.4.0000.1018", // + (new Date()).getTime(),
    baseUrl: 'App',
    paths: {
        'text': '../libraries/require/js/text',
        'i19n/strings': '../app/i19n/strings',

        //'jqueryuitouch': '../libraries/jquery.ui.touch-punch/js/jquery.ui.touch-punch.min',
        //'jqueryui': '../libraries/jquery.ui/js/jquery-ui-1.10.3.custom.min',
        //'jquerylayout': '../libraries/jquery.layout/js/jquery.layout.min',
        //'jquerytmpl': '../libraries/jquery.tmpl/js/jquery.tmpl',
        //'bootstrap': '../libraries/bootstrap/js/bootstrap.min',
        //'amplify': '../libraries/amplify/js/amplify',
        //'ace': '../libraries/ace/js/ace.min',
        //'aceextra': '../libraries/ace/js/ace-extra.min',
        //'aceelements': '../libraries/ace/js/ace-elements.min',
        //'acefuelux': '../Libraries/ace/js/fuelux.wizard.min',
        //'fastclick': '../libraries/fastclick/js/fastclick',
        //'moment': '../libraries/moment/js/moment.min',
        //'toastr': '../libraries/toastr/js/toastr', //throws error in release when .min
        ////'jquery': '../libraries/jquery/js/jquery-2.1.1',

        'dropzone': '../libraries/ace/js/dropzone',

        'fileplankoex': '../libraries/fileplan/js/ko-extensions',
        'fileplanstringex': '../libraries/fileplan/js/string-extensions',
        'fileplanutil': '../libraries/fileplan/js/utils',

        'durandal': '../libraries/durandal/js',
        'plugins': '../libraries/durandal/js/plugins',
        'transitions': '../libraries/durandal/js/transitions',

        'services/log': '../libraries/logf/js/logf',
        //'kendoculture': '../libraries/kendo/cultures/kendo.culture.' + window.fileplan.settings.locale + '.min'
        //'kendoculture': 'empty:' //'kendoculture': '../libraries/kendo/cultures/kendo.culture.' + window.fileplan.settings.locale + '.min'      
    },
    shim: {
        ////'jquery': { exports: 'jquery' },
        //'jqueryuitouch': { exports: 'jqueryuitouch' },
        //'jqueryui' : { exports: 'jqueryui' },
        //'jquerylayout': { exports: 'jquerylayout' },
        //'jquerytmpl': { exports: 'jquerytmpl' },
        //'amplify': { deps: ['jquery'], exports: 'amplify' },
        //'ace': { exports: 'ace' },
        //'acefuelux': { deps: ['ace'], exports: 'acefuelux' },
        //'aceelements': { deps: ['acefuelux'], exports: 'aceelements' }

        //'i19n/strings': { deps: ['i19n', 'cultures'], exports: 'i19n/strings' }
    },
    //config: { i19n: { locale: 'en-US' } },
    //config: { i19n: { locale: window != null ? window.fileplan.settings.locale : "en-US" } },
    waitSeconds: 0
});

define('jquery', [],function () { return jQuery; });
define('knockout', ko);
define('ace', ace);
define(
'main',[
    "durandal/system",
    "durandal/app",
    "durandal/viewLocator",
    "durandal/composition",    
    "plugins/router",
    "plugins/widget",
    "plugins/dialog",
    "services/config",
    "services/log",
    "services/session",
    "services/eventbroker",
    "providers/dataprovider",
    "i19n!i19n/strings",
    "dropzone",
    //"amplify",    
    "fileplankoex",
    "fileplanstringex",
    "fileplanutil"
    //"jquerylayout",
    //"jqueryui",
    //"bootstrap",
    //"acedropzone",
    //"aceelements",
    //"fastclick",
    //"moment"    
],
function (system, app, viewLocator, composition, router, widget, dialog, config, log, session, eventBroker, dataProvider, i19n, Dropzone) { //, amplify
    $(function () {
        FastClick.attach(document.body);        
    });
    

    i19n.locale = window.fileplan.settings.locale;

    app.start().then(function () {               

        //#region sort i19n.to
        //var to = [];
        //for (var property in i19n.to) {
        //    if (i19n.to.hasOwnProperty(property)) {
        //        to.push({ field: property, value: property + ': "' + i19n.to[property] + '",' });
        //    }
        //}
        //to = _.sortBy(to, function (itm) { return itm.field; });
        //_.map(to, function (itm) {
        //    console.warn(itm.value);
        //});
        //#endregion

        app.title = "fileplan";
        app.isBusy = ko.observable(false);

        router.makeRelative({ moduleId: 'viewmodels' }); // all module ids are relative to the viewmodels directory

        // global ajax error handlers
        eventBroker.on("viewmodels/main", config.events.errors.ajax, function (result, statusCode, xhr) {
            if (statusCode == 401) {
                var activeInstruction = router.activeInstruction();
                if (!activeInstruction || activeInstruction.config.route != "login") {
                    log.system("401: %o", activeInstruction);
                    //session.logout();
                    //return;
                }
            }

            // show a toast of the error message/s
            if (_.isArray(result)) {
                _.each(result, function (error) {
                    toastr.error(error.phrase, i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
                });
            } else {
                toastr.error(result, i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
            }
        });
        eventBroker.on("viewmodels/main", config.events.errors.serverException, function (result, statusCode, xhr) {
            if (_.isArray(result)) {
                _.each(result, function (error) {
                    //toastr.error(error.phrase, i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
                    log.error("Server Exception Details: %o", error.phrase); // check the chrome dev. tool network tab for the actual exception.
                    toastr.error("An error occurred on the server. Please refresh the page before continuing.", i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
                });
            } else {
                log.error("Server Exception Details: %o", result); // check the chrome dev. tool network tab for the actual exception.
                toastr.error("An error occurred on the server. Please refresh the page before continuing.", i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
            }
        });

        app.setRoot("viewmodels/controller");

        //if (window.fileplan.settings.useMocks) {
        //    require(['mocks/mock'], function (mock) {
        //        mock.init();
        //        app.title = "mock";
        //    });
        //} else {
        //    _.each(amplify.store.sessionStorage(), function (value, key) {
        //        if (key.indexOf("mock-") == 0)
        //            amplify.store.sessionStorage(key, null);
        //    });
        //}
    });
});

